import React, { Fragment } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next/';
import _ from 'lodash';

import Icon from 'src/components/Icon/Icon';
import './ToteBetDetails.scss';
import { toRoman } from 'src/utils/utils';

interface Props {  marketName: string,
  outcome: string,
  odds: number,
  index: number,
  oddsChanged: string
  selectedSlip: number,
  orderedPosition: any
  showBanker: boolean,
  onBankerToggle: () => void,
  banker: boolean,
  permutationsCount: number,
  changePermutations: () => {}
}

function ToteBetDetails({ marketName,
  outcome,
  odds,
  index,
  oddsChanged,
  selectedSlip,
  showBanker,
  banker,
  permutationsCount,
  changePermutations,
  onBankerToggle,
  orderedPosition
}: Props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div className="totebet-details">
      {
        (selectedSlip === 2 || (selectedSlip === 1 && showBanker)) && (
          <span
            className={ classNames('totebet-details__banker', { 'totebet-details__banker--selected': banker }) }
            onClick={ onBankerToggle }
          >
                B
          </span>
        )
      }
      <div className="totebet-details__market">
        <span className="totebet-details__index">{ index +1 }.</span>
        <span className="totebet-details__market-name">{ marketName }</span>
        <span className="totebet-details__market-outcome">{ outcome } </span>
      </div>
      <div className="totebet-details__odds-container">
        <span className={
          classNames({
            'totebet-details__odds': true,
            'totebet-details__odds--increased': oddsChanged === 'increased',
            'totebet-details__odds--decreased': oddsChanged === 'decreased'
          })
        }
        >
          {
            oddsChanged &&
          <div className={
            classNames({
              'totebet-details__arrow': true,
              'totebet-details__arrow--up': oddsChanged === 'increased',
              'totebet-details__arrow--down': oddsChanged === 'decreased'
            })
          }
          />
          }
          { odds == +odds ? odds : 'TP' }
        </span>
        <Icon icon="trash" className="totebet-details__clear" onClick={ () => dispatch.betslip.removeBetAtIndex(index) } />
      </div>
      <div className="totebet-details__multiple-selection">
        {
          _.map(orderedPosition, (position, number) => {
            return (
              <Fragment key={ number }>
                {
                  !_.isEmpty(position) && <>
                    <span className="totebet-details__position"> { typeof(number) !== 'string' ? toRoman(number) : number } -</span>
                    <span className="totebet-details__numbers">{ position.toString() }</span>
                  </>
                }
              </Fragment>
            );
          })
        }
        {
          permutationsCount && permutationsCount > 1 &&
         <span className="numberbet-details__combo" onClick={ changePermutations }>{ `${ t('betslip.combo') }: ${ permutationsCount }` }</span>
        }
      </div>
    </div>
  );
}

export default ToteBetDetails;
